import { render } from "./AgentsView.vue?vue&type=template&id=248df4e8&scoped=true"
import script from "./AgentsView.vue?vue&type=script&lang=js"
export * from "./AgentsView.vue?vue&type=script&lang=js"

import "./AgentsView.vue?vue&type=style&index=0&id=248df4e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248df4e8"]])

export default __exports__